// 打印小票设置（localStorage 持久化）

const STORE_NAME_KEY = 'receipt_store_name';
const FOOTER_KEY = 'receipt_footer';
const PAPER_WIDTH_KEY = 'receipt_paper_width';
const COL_WIDTHS_KEY = 'receipt_col_widths';
const SALE_LABEL_KEY = 'receipt_sale_label';
const PURCHASE_LABEL_KEY = 'receipt_purchase_label';

// 默认列宽（合计 32 字符，58mm 纸宽；80mm 自动放大）
const DEFAULT_COL_WIDTHS = { name: 12, qty: 4, price: 7, sub: 7 };

// 列宽允许范围
const COL_LIMITS = {
  name:  { min: 6,  max: 18 },
  qty:   { min: 3,  max: 6  },
  price: { min: 5,  max: 10 },
  sub:   { min: 5,  max: 10 }
};

function clampCol(key, v) {
  const { min, max } = COL_LIMITS[key];
  return Math.max(min, Math.min(max, Math.round(Number(v) || DEFAULT_COL_WIDTHS[key])));
}

export const receiptSettings = {
  // 店名（顶居中）
  getStoreName() {
    return localStorage.getItem(STORE_NAME_KEY) || '';
  },
  setStoreName(v) {
    localStorage.setItem(STORE_NAME_KEY, v || '');
  },

  // 页脚（底居中）
  getFooter() {
    return localStorage.getItem(FOOTER_KEY) || '谢谢惠顾';
  },
  setFooter(v) {
    localStorage.setItem(FOOTER_KEY, v || '谢谢惠顾');
  },

  // 纸张宽度：58 或 80（mm）
  getPaperWidth() {
    return Number(localStorage.getItem(PAPER_WIDTH_KEY)) || 80;
  },
  setPaperWidth(v) {
    localStorage.setItem(PAPER_WIDTH_KEY, String(v));
  },

  // 列宽（4 列：种类 / 数量 / 单价 / 小计）
  getColumnWidths() {
    try {
      const raw = localStorage.getItem(COL_WIDTHS_KEY);
      if (raw) {
        const obj = JSON.parse(raw);
        return {
          name: clampCol('name', obj.name),
          qty: clampCol('qty', obj.qty),
          price: clampCol('price', obj.price),
          sub: clampCol('sub', obj.sub)
        };
      }
    } catch (e) {
      // 解析失败走默认
    }
    return { ...DEFAULT_COL_WIDTHS };
  },
  setColumnWidths(obj) {
    const safe = {
      name: clampCol('name', obj?.name),
      qty: clampCol('qty', obj?.qty),
      price: clampCol('price', obj?.price),
      sub: clampCol('sub', obj?.sub)
    };
    localStorage.setItem(COL_WIDTHS_KEY, JSON.stringify(safe));
  },
  // 列宽上下限（前端 slider 用）
  getColumnLimits() {
    return COL_LIMITS;
  },

  // 销售单标题（默认 "销售单"，可改 "出货单" 等）
  getSaleLabel() {
    return localStorage.getItem(SALE_LABEL_KEY) || '销售单';
  },
  setSaleLabel(v) {
    localStorage.setItem(SALE_LABEL_KEY, v || '销售单');
  },

  // 进货单标题（默认 "进货单"，可改 "收货单" 等）
  getPurchaseLabel() {
    return localStorage.getItem(PURCHASE_LABEL_KEY) || '进货单';
  },
  setPurchaseLabel(v) {
    localStorage.setItem(PURCHASE_LABEL_KEY, v || '进货单');
  },

  // 根据 type 取对应标题
  getTypeLabel(type) {
    return type === 'purchase'
      ? this.getPurchaseLabel()
      : this.getSaleLabel();
  }
};

// 默认列宽也导出，前端 escpos.js 可作 fallback
export { DEFAULT_COL_WIDTHS };